import React from 'react';
import PropTypes from 'prop-types';

export default function CustomFieldPreview(props) {
    return (
        <div className="details-item">
            <div className="label-details ui5-txt-not-important-tiny">Preview:</div>
            <div className={Classes("cf-preview", "p-l-10", "p-r-10", "flex-r", "fl-ac", "fl-sb", "fl-wrap", {'no-padding': props.noPadding})}>
                {props.children}
            </div>
        </div>
    );
}

CustomFieldPreview.propTypes = {
    noPadding: PropTypes.bool
}
